export default "__VITE_ASSET__DuJonTmY__"